import { type ReactNode } from 'react';

import { CopyToClipboardButton } from '../../Clipboard/index.js';

interface MarkdownCopyToClipboardProps {
  content: ReactNode;
}

export function MarkdownCopyToClipboard(props: MarkdownCopyToClipboardProps) {
  const { content } = props;
  if (typeof content !== 'string') {
    return null;
  }

  return <CopyToClipboardButton content={content} />;
}
